import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/security/twoFactorSetup';
import { clear as clearEnable } from '../../actions/security/twoFactorEnable';
import { clear as clearRecoveryCodes } from '../../actions/security/twoFactorRecoveryCodes';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation() {
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/user/2fa/setup`,
      {},
      { headers: getLocalUser() },
    );
    // Starting a (new) enrollment hides any recovery codes still on screen.
    yield put(clearEnable());
    yield put(clearRecoveryCodes());
    yield put(fetchSuccess(unwrap(res)));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.data?.message
      || err?.response?.data?.message
      || 'Could not start 2FA setup';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
